import script from "./WinesList.vue?vue&type=script&setup=true&lang=js"
export * from "./WinesList.vue?vue&type=script&setup=true&lang=js"

import "./WinesList.vue?vue&type=style&index=0&id=334da953&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-334da953"]])

export default __exports__